import { render, staticRenderFns } from "./DynamicCareer.vue?vue&type=template&id=53afdf5a&scoped=true"
import script from "./DynamicCareer.vue?vue&type=script&lang=js"
export * from "./DynamicCareer.vue?vue&type=script&lang=js"
import style0 from "./DynamicCareer.vue?vue&type=style&index=0&id=53afdf5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afdf5a",
  null
  
)

export default component.exports